import React from "react";
import { Navigate } from "react-router-dom";
import { useFeatureFlag } from "hooks/useFeatureFlag";

type Props = {
  flagName: string;
  fallback?: string;
  children: React.ReactNode;
  loading?: React.ReactNode;
};

const FeatureFlagRoute: React.FC<Props> = ({
  flagName,
  fallback = "/Gating/New",
  children,
  loading = null,
}) => {
  const enabled = useFeatureFlag(flagName);

  if (enabled === undefined || enabled === null) return <>{loading}</>;

  return enabled ? <>{children}</> : <Navigate to={fallback} replace />;
};

export default FeatureFlagRoute;
